import React from "react";
import FormLabel from "../../../components/HtmlMarkup/FormLabel";
import Controls from "../../../components/controls/control";

export default function QuizOptions({
  quizId,
  option,
  selectedOptions,
  handleOptionChange,
}) {
  return (
    <FormLabel htmlFor={`option${option?.id}_q${quizId}`}>
      <Controls.Input
        id={`option${option?.id}_q${quizId}`}
        type="checkbox"
        checked={selectedOptions[`option${option?.id}_q${quizId}`]}
        onChange={handleOptionChange}
        required={false}
      />
      {option?.option}
    </FormLabel>
  );
}
